
import { defineComponent, SetupContext, ref } from "vue";
import NativeClient from "@/client/native-client";
import { FoodItem } from "@/types/pantry";
export default defineComponent({
  name: "PantrySearchTagItem",
  props: {
    data: {
      type: FoodItem,
      default: null,
    }
  },
  setup(props, context: SetupContext) {
    NativeClient.sendDebugLog("PantrySearchTagItem data=" + JSON.stringify(props.data));

    const onClick = () => {
      context.emit("delete-food", props.data);
    };
    const getIcon = () => {
      return (props.data != null) ? props.data.icon : null;
    };
    const getName = () => {
      return (props.data != null) ? props.data.name : "";
    };
    const isShowIcon = () => {
      return (props.data != null && props.data.icon != null);
    };
    return {
      onClick,
      getIcon,
      isShowIcon,
      getName
    };
  }
});
